import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Spin ,Image, Typography, Table, Card, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;


function Sector() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [sectors, setSectors] = useState([]);
    const [filteredSectors, setFilteredSectors] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editSector, setEditSector] = useState(null);
    const [selectedSector, setSelectedSector] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchSectors();
    }, []);

    const fetchSectors = async () => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/sector/all`, { headers });
            setSectors(response.data);
            setFilteredSectors(response.data);
        } catch (error) {
            AlertError("Failed to fetch Sectors");
        } finally {
            setLoading(false);
        }
    };

 
    const showModal = () => {
        setIsModalOpen(true);
    };
    const showEditModal = (sector) => {
     
        setEditSector(sector);
        form.setFieldsValue({
           // ProductTypeCode: ProductType.ProductTypeCode,
            sectorName: sector.sectorName,
            sectorActiveStatus: sector.sectorActiveStatus === true,
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    
    const handleCreateSector = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();

            const requestData = {
                sectorName: values.sectorName,
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/master/sector/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Sector successfully added!");
                handleCancel();
                fetchSectors();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add Sector!");
        }finally {
            setLoading(false);
        }
    };
    const handleUpdateSector = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();
            const requestData = {
                sectorId: editSector.sectorId,
                sectorName: values.sectorName,
                sectorActiveStatus: values.sectorActiveStatus,
            };

            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.post(
                `${ApiURL}/master/sector/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Sector successfully updated!");
                handleCancel();
                fetchSectors();
            }
        } catch (error) {
            console.log(error);
            AlertError(error.response?.data?.message || "Failed to update Sector!");
        }finally {
            setLoading(false);
        }
    };

    const handleDeleteSector = async (id) => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            await axios.get(`${ApiURL}/master/sector/delete/${id}`, { headers });
            AlertSuccess("Sector deleted successfully!");
            fetchSectors();
        } catch (error) {
            AlertError("Failed to delete Sector!");
        }finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        setLoading(true);
        let filtered = sectors;

        if (selectedSector) {
            filtered = filtered.filter(sector => sector.sectorId === selectedSector);
        }

        if (keyword) {
            filtered = filtered.filter(sector => sector.sectorId.toLowerCase().includes(keyword.toLowerCase()));
        }

        setFilteredSectors(filtered);
       
     setLoading(false);
        
    };

   
    const handleReset = () => {
        setLoading(true);
        setKeyword('');
        setSelectedSector(null);
        setFilteredSectors(sectors);
        setLoading(false);
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this Sector?"
                        onConfirm={() => handleDeleteSector(record.sectorId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: 'Sector Name',
            dataIndex: 'sectorName',
            key: 'sectorName',
            sorter: (a, b) => a.sectorName.localeCompare(b.sectorName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'sectorActiveStatus',
            key: 'sectorActiveStatus',
            render: (sectorActiveStatus) => (
                <Tag color={sectorActiveStatus === true ? "green" : "red"}>
                    {sectorActiveStatus === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];
    return (
        <Spin spinning={loading} tip="Processing...">
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item>Sectors</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'10px' }}>
                                <Button type="primary" onClick={showModal}>Create New</Button>
                            </Col>

                        </Row>
                        
                        <Typography.Title level={5}>List of Sector</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredSectors}
                            rowKey="sectorId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />

                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New Sector"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateSector}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[
                            { required: true, message: "ProductType code is required" },
                            { len: 4, message: "ProductType code must be exactly 4 characters" },
                        ]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}

                    <Form.Item
                        label="Sector Name"
                        name="sectorName"
                        rules={[{ required: true, message: "Sector name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit Sector"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateSector}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[{ required: true, message: "ProductType code is required" }, { len: 4, message: "ProductType code must be exactly 4 characters" }]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}
                    <Form.Item
                        label="Sector Name"
                        name="sectorName"
                        rules={[{ required: true, message: "Sector name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Sector Status"
                        name="sectorActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={editSector?.selectedSector?.sectorActiveStatus === true} />
                    </Form.Item>
                </Form>
            </Modal>
            
        </Layout>
        </Spin>
    );
}

export default Sector;